<template>
</template>

<script>
  export default {
    props: ['type', 'message'],

    data() {
      return {
        //
      }
    },

    methods: {
      showMessage() {
        if (this.message && (this.type == 'success' || this.type == 'error' || this.type == 'warning')) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              duration: 3000,
              message: this.message,
              type: this.type
            });
          }, 1500);
        }
      }
    },

    mounted() {
      this.showMessage();
    }
  }
</script>

<style lang="scss">
</style>